// @flow
import 'pdfjs-dist/build/pdf.worker.min.mjs'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

import { useResizeObserver } from '@wojtekmaj/react-hooks'
import Spinner from 'components/Spinner'
import * as React from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import Flex from 'ui/atoms/Flex'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString()

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
}

const resizeObserverOptions = {}

const maxWidth = 800

type PDFFile = string | File | null

type Props = {
  file: PDFFile,
  onLoad?: () => void,
}

function PdfViewer({ file, onLoad }: Props): React.Node {
  const [numPages, setNumPages] = React.useState<number | void>()
  const [containerRef, setContainerRef] = React.useState<HTMLElement | null>(
    null
  )
  const [containerWidth, setContainerWidth] = React.useState<number | void>()

  const onResize = React.useCallback((entries) => {
    const [entry] = entries

    if (entry) {
      setContainerWidth(entry.contentRect.width)
    }
  }, [])

  useResizeObserver(containerRef, resizeObserverOptions, onResize)

  const onDocumentLoadSuccess = React.useCallback(
    ({ numPages: nextNumPages }: { numPages: number }) => {
      setNumPages(nextNumPages)
      onLoad && onLoad()
    },
    [onLoad]
  )

  return (
    <div ref={setContainerRef}>
      <Document
        file={file}
        loading={
          <Flex align="center" className="w-full" justify="center">
            <Spinner color="onLight" size={40} />
          </Flex>
        }
        onLoadSuccess={onDocumentLoadSuccess}
        options={options}
      >
        {Array?.from(new Array(numPages || 0), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            loading={<Spinner color="onLight" size={40} />}
            pageNumber={index + 1}
            width={containerWidth || maxWidth}
          />
        ))}
      </Document>
    </div>
  )
}

export default PdfViewer
